import Router from "./router";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <div className="w-full overflow-x-hidden">
      <Router />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </div>
  );
}

export default App;

// import Router from "./router";
// import { Document, Page, Text, View, StyleSheet, PDFViewer } from "@react-pdf/renderer";

// // FULL SIZE
// // height: 840,
// // width: 594,
// // DEFAULT DPI 72 -> 2.834 dot/mm

// const styles = StyleSheet.create({
//   section: {
//     backgroundColor: "red",
//     height: 772,
//     width: 526,
//     margin: 34,
//   },
//   section2: {
//     backgroundColor: "red",
//     height: 100,
//     width: 10,
//   },
// });

// function App() {
//   return (
//     <div className="w-full h-full">
//       {/* <div className="w-full overflow-x-hidden">
//     <Router />

//       </div> */}
//       <PDFViewer className="w-full h-screen border">
//         {/* Start of the document*/}
//         <Document>
//           {/*render a single page*/}
//           <Page size="A4">
//             <View style={styles.section}>
//               <Text>Hello</Text>
//             </View>
//           </Page>
//         </Document>
//       </PDFViewer>
//     </div>
//   );
// }

// export default App;
